export const openExternalLink = (url) => {
    if (!url) return;

    if (url.startsWith("/") || url.startsWith("./") || url.startsWith("../")) {
        window.open(url, "_blank", "noopener,noreferrer");
        return;
    }

    const preparedUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    window.open(preparedUrl, "_blank", "noopener,noreferrer");
};
